import React, { useState, useEffect } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { Typography, Select } from "antd";
import "./style.css";
import { ApiCaller } from "../../../config";
import { Loader } from "../../../components";

const { Option } = Select;

const AverageSpendPerBooking = ({ id }) => {


    const [dateType, setDateType] = useState("monthly");
    const [chartData, setChartData] = useState([]);
    const [loading, setIsLoading] = useState(false);

    useEffect(() => {
        if (id) {
            (async () => {
                setIsLoading(true)
                try {
                    let response = await ApiCaller.Get(`/admin/service-user/${id}/spendings-average?dateType=${dateType}`);
                    let dataValuesCheck = response?.data?.data?.chart?.data;
                    if (dataValuesCheck?.length > 0 && dataValuesCheck.some(val => val > 0)) {
                        const formatted = response?.data?.data?.chart.labels.map((label, index) => ({
                            name: label,
                            value: response?.data?.data?.chart?.data[index],
                        }));
                        setChartData(formatted);
                    }
                    else {
                        setChartData([])
                    }
                }
                catch (error) {
                    console.log(error)
                }
                finally {
                    setIsLoading(false)
                }
            })()
        }
    }, [id, dateType])

    return (
        <div className="booking-frequency-container">
            {
                loading ?
                    <div className="user-table-loader-container">
                        <Loader.Circular />
                    </div>
                    :


                    chartData?.length > 0 ?
                        <>
                            <div className="booking-frequency-header">
                                <div className="custom-representation-bar-container">
                                    <div className="bar-container">
                                        <div className="bar-1"></div>
                                        <small>on hover (values)</small>
                                    </div>

                                    <div className="bar-container">
                                        <div className="bar-2"></div>
                                        <small>on hover (0 value)</small>
                                    </div>
                                </div>
                                <Select
                                    value={dateType}
                                    onChange={(value) => setDateType(value)}
                                    style={{ width: 150 }}
                                    className="booking-frequency-select"
                                >
                                    <Option value="weekly">Weekly</Option>
                                    <Option value="monthly">Monthly</Option>
                                    <Option value="quarterly">Quarterly</Option>
                                    <Option value="yearly">Yearly</Option>
                                </Select>
                            </div>

                            <div className="frequency-chart-wrapper">
                                <ResponsiveContainer width="100%" height={250}>
                                    <BarChart
                                        data={chartData}
                                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                                        barCategoryGap="10%"
                                    >
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                        <XAxis
                                            dataKey="name"
                                            axisLine={false}
                                            tickLine={false}
                                            tick={{ fontSize: 12, fill: "#555" }}
                                        />
                                        <YAxis
                                            axisLine={false}
                                            tickLine={false}
                                            tick={{ fontSize: 12, fill: "#555" }}
                                        />
                                        <Tooltip
                                            contentStyle={{ fontSize: 13 }}
                                            formatter={(value) => [value, dateType]}
                                        />

                                        {/* Single bar — color based on filter type */}
                                        <Bar
                                            dataKey="value"
                                            fill={
                                                '#FFC107'
                                            }
                                            radius={[3, 3, 0, 0]}
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </>
                        :
                        <p style={{ textAlign: 'center' }}>No data Available</p>
            }
        </div>
    );
};

export default AverageSpendPerBooking;
